import { Utente } from "./utente.model";

export class FileCaricatoDTO {
    estensione:String;
}
  